//@ts-nocheck

import normalizeImage from '../base/ImageBase'
// import normalizerForm from '@models/base/Form'
// import normalizeModalForm from '@models/base/ModalForm'

interface Title {
  as: string
  typo: string
  content: string
}

interface CTA {
  label: string
}

interface Image {
  alternativeText?: string
  name?: string
  url?: string
  width?: number
  height?: number
}

interface FormMeta {
  [key: string]: any
}

interface BannerProps {
  type: string
  sectionId: string
  colorScheme: string
  title: Title
  subtitle: Title
  ctaPrimary?: CTA
  ctaSecondary?: CTA
  image?: Image
  imageShape?: string
  submitButtonLabel?: string
  formMeta?: FormMeta
  modalPrimary?: any
  modalSecondary?: any
}

interface NormalizedBanner {
  type: string
  sectionId: string
  colorScheme: string
  title: Title
  subtitle: Title
  ctaPrimary?: CTA
  ctaSecondary?: CTA
  image?: ReturnType<typeof normalizeImage>
  imageShape?: string
  submitButtonLabel?: string
  preTitle?: Title
//   form?: ReturnType<typeof normalizerForm>
//   modalPrimary?: ReturnType<typeof normalizeModalForm>
//   modalSecondary?: ReturnType<typeof normalizeModalForm>
}

const Banner = ({
  type,
  sectionId,
  colorScheme,
  title,
  subtitle,
  ctaPrimary,
  ctaSecondary,
  image,
  imageShape,
  submitButtonLabel,
  preTitle,
//   formMeta,
//   modalPrimary,
//   modalSecondary,
}: BannerProps): NormalizedBanner => {
//   const normalizedForm = formMeta ? normalizerForm({ ...formMeta }) : undefined

  const normalizedData: NormalizedBanner = {
    type,
    sectionId,
    colorScheme,
    title,
    subtitle,
    ctaPrimary,
    ctaSecondary,
    image: image ? normalizeImage(image) : undefined,
    imageShape,
    submitButtonLabel,
    pretitle: preTitle,
    // form: normalizedForm,
    // modalPrimary: modalPrimary ? normalizeModalForm(modalPrimary) : undefined,
    // modalSecondary: modalSecondary ? normalizeModalForm(modalSecondary) : undefined,
  }

  return normalizedData
}

export default Banner
